/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class ErrorCodeService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** 에러 코드 목록 조회 */
    getAllErrorCodes = async (errorType) => {
        const { data } = await this.get(apiWrapper.managerApiV1('/error-codes'), {
            errorType,
        });
        return data.data;
    };
    /** 에러 히스토리 목록 조회 */
    getErrorHistory = async (params) => {
        const { data } = await this.get(apiWrapper.managerApiV1('/error-history'), { ...params });
        return data;
    };
}
export { ErrorCodeService };
